const Colors = {
    primary: '#45368f',
    white: '#fff',
}

export default Colors